module.exports = __webpack_public_path__ + "img/tpc-34.c0eed730.jpg";